import { PATH, PATH_PROJECTS } from './path'

export const PRIVAT_INITIAL_ROUTE = `/${PATH.PROJECTS}/${PATH_PROJECTS.MY}`
